import { TAG_STATUS } from '@evinced-private/ui-common';

// Tag interfaces for better type safety
export interface StatusTag {
	status: TAG_STATUS;
	text: string;
}

export interface TrendTag {
	icon?: string;
	status: TAG_STATUS;
	text: string;
}

// Enums for better type safety
export enum AccessibilityStatus {
	POOR = 'poor',
	MODERATE = 'moderate',
	GOOD = 'good',
	EXCELLENT = 'excellent'
}

export enum TrendDirection {
	UP = 'up',
	DOWN = 'down'
}
